;(function (angular) {
   'use strict'

   // Ensures that an `input type="number"` is formatted with two digits after the decimal on blur.

   angular.module('azure.util').directive('asCurrencyFormatInput', currencyFormatInput)

   function currencyFormatInput($filter) {
      return {
         require: 'ngModel',
         link: link,
         restrict: 'A',
         scope: {
            model: '=ngModel',
         },
      }

      function link(scope, element, attrs, ngModelCtrl) {
         ngModelCtrl.$render = function () {
            const value = ngModelCtrl.$modelValue
            if (value === undefined || value === null || value === '') {
               return
            }

            // Normalize to a finite number (handles strings like "1,234.56")
            const n = typeof value === 'number' ? value : parseFloat(String(value).replace(/,/g, ''))
            if (!Number.isFinite(n)) {
               element.val('')
               return
            }

            // For number inputs, use plain numeric formatting (no commas).
            // For text inputs, include thousands separators.
            if (element[0].type === 'number') {
               element.val(n.toFixed(2))
            } else {
               element.val($filter('number')(n, 2))
            }
         }

         element.on('blur', ngModelCtrl.$render)

         element.on('keydown', function (e) {
            if (e.key === 'Enter') {
               e.target.blur()
            }
         })
      }
   }
})(angular)
